module.exports = __webpack_public_path__ + "img/indianexpress.9b2109bc.jpg";